import { Wifi, WifiOff, AlertCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { realtimeService } from "@/lib/realtime-service";

interface RealtimeStatusProps {
  isConnected: boolean;
  isEnabled?: boolean;
  className?: string;
}

export function RealtimeStatus({ isConnected, isEnabled = true, className = "" }: RealtimeStatusProps) {
  const handleReconnect = () => {
    realtimeService.reconnect();
  };

  if (!isEnabled) {
    return (
      <div className={`flex items-center gap-1 ${className}`}>
        <Badge variant="secondary" className="flex items-center gap-1 text-xs">
          <AlertCircle className="h-3 w-3" />
          <span className="hidden sm:inline">ئۆفلاین</span>
        </Badge>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleReconnect}
          className="h-6 px-2 text-xs"
        >
          دووبارە هەوڵدان
        </Button>
      </div>
    );
  }

  return (
    <Badge 
      variant={isConnected ? "default" : "destructive"} 
      className={`flex items-center gap-1 text-xs ${className}`}
    >
      {isConnected ? (
        <>
          <Wifi className="h-3 w-3" />
          <span className="hidden sm:inline">زیندوو</span>
        </>
      ) : (
        <>
          <WifiOff className="h-3 w-3" />
          <span className="hidden sm:inline">نازیندوو</span>
        </>
      )}
    </Badge>
  );
}